module.exports = __webpack_public_path__ + "static/media/logo.93b86834.png";